// You can customize the template with the help of this file

//Template config options
const baseDevAPIURL =
  process.env.REACT_APP_BASE_DEV_API ||
  "https://erp-api.alburoujsportsclub.com/api";
const baseProdAPIURL =
  process.env.REACT_APP_BASE_PROD_API ||
  "https://erp-api.alburoujsportsclub.com/api";
// let baseApiUrl = process.env.NODE_ENV === 'production' ? baseProdAPIURL : baseDevAPIURL;
// let baseAgpiUrl = process.env.REACT_APP_API || "https://erp-api.alburoujsportsclub.com/api";
const themeConfig = {
  app: {
    appName: "Alburouj Sports Club",
    appLogoImage: require("@src/assets/images/logo/broujLogo_.png").default,
    //api_url: "https://erp-api.alburoujsportsclub.com/api", //development
    // reports_url: "http://34.203.111.164:85/?rpt=darsalam/voucher_print",
    reports_url: reportBaseUrl,
    api_url: process.env.REACT_APP_BASE, //darsalam
    // api_url: baseApiUrl,
  },
  layout: {
    isRTL: true,
    skin: process.env.REACT_APP_DEV_THEME || "light", // light, dark, bordered, semi-dark
    routerTransition: "fadeIn", // fadeIn, fadeInLeft, zoomIn, none or check this for more transition https://animate.style/
    type: "horizontal", // vertical, horizontal
    contentWidth: "full", // full, boxed
    menu: {
      isHidden: false,
      isCollapsed: false,
    },
    navbar: {
      // ? For horizontal menu, navbar type will work for navMenu type
      type: "floating", // static , sticky , floating, hidden
      backgroundColor: "white", // BS color options [primary, success, etc]
    },
    footer: {
      type: "static", // static, sticky, hidden
    },
    customizer: false,
    scrollTop: true, // Enable scroll to top button
  },
};

export default themeConfig;
